import { IExpression } from "@@expressions";
import { IContainerComponent } from "./IContainerComponent";

export enum DrawerMenuDirection {
  Left = "Left",
  Right = "Right",
}

export type DrawerMenuModel = IContainerComponent & {
  Items: DrawerMenuItemModel[];
  Collapsible?: boolean;
  DefaultOpen?: boolean;
  CollapsedWidth?: number;
  ExpandedWidth?: number;
  ContentWidth?: number;
  PersistedStateKey?: string;
  ItemQueryKey?: string;
  PersistSelection?: boolean;
  Direction?: DrawerMenuDirection;
  OpeningDirection?: DrawerMenuDirection;
  OverlayContent?: boolean;
  UsePaper?: boolean;
};

export type DrawerMenuItemModel = {
  Label: string;
  IconName?: string;
  Description?: string;
  Badge?: IExpression;
  Hidden?: IExpression;
  Disabled?: IExpression;
};
